import {
  BILLING_STATUS_POLICY,
  SUBSCRIBABLE_SERVICE_UNIQUE_NAMES,
  type BillingStatus,
  type SubscribableServiceUniqueName,
} from './status-policy-table';

export const isBillingStatus = (status: string | null | undefined): status is BillingStatus =>
  !!status && status in BILLING_STATUS_POLICY;

export const getStatusPolicy = (status: BillingStatus | null | undefined) =>
  isBillingStatus(status) ? BILLING_STATUS_POLICY[status] : undefined;

export const canAccessService = (status?: BillingStatus | null): boolean => !!getStatusPolicy(status)?.canAccessService;

export const isSubscribableService = (serviceUniqueName?: string): serviceUniqueName is SubscribableServiceUniqueName =>
  !!serviceUniqueName && SUBSCRIBABLE_SERVICE_UNIQUE_NAMES.includes(serviceUniqueName as SubscribableServiceUniqueName);
